import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateCryodexLinks} from '../containers/Home/actions';
const storageHandler = new StorageHandler();


function* getCryodexLinks(){

    const Network = new NetworkHandler();
  
    try{

      const response = yield Network.requestGetCryodexLinks();

      if (!(response instanceof Error)) {
          yield put(
            updateCryodexLinks(
                response
              )
            );
		 
        } else {
          yield put(
            error({
              message: `Unable to get cryodex links. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to get cryodex links, please try again.${errorMsg}`,
            })
        );
    }

}

export default function* usersSagas() {
  yield takeLatest(ACTIONS.CRYODEX_CRYODEX_LINKS_GET, getCryodexLinks);
}

